import { createContext } from "react";

import { Player } from "types/player";

const ScoreCardDialogContext = createContext({
  openScoreCardDialog: (player: Player, teammates: Player[]) => {},
});

export default ScoreCardDialogContext;
